
import { defineComponent } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { baseFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
// import VehicleSpecModal from './VehicleSpecModal.vue';
import AddToCartModal from './AddToCartModal.vue';

export default defineComponent({
  name: 'VehicleItem',
  components: {
    LeftOutlined,
    RightOutlined,
    PreviewImageModal,
    // VehicleSpecModal,
    AddToCartModal
  },
  data() {
    return {
      showPreviewModal: false,
      showSpecModal: false,
      showAddToCartModal: false
    };
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.v-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    getPreviewImgs() {
      const images: string[] = (this.vehicle.showImg || '')
        .split(',')
        .filter(s => s);

      return images.length > 0 ? images.map(i => `${baseFileUrl}${i}`) : [''];
    },
    onImgClick() {
      this.showPreviewModal = true;
    },
    getAttrImage() {
      return this.vehicle.attributeImg
        ? [`${baseFileUrl}${this.vehicle.attributeImg}`]
        : [''];
    },
    handleAfterClose() {
      this.showSpecModal = false;
      this.showPreviewModal = false;
      this.showAddToCartModal = false;
    },
    handleSpecification() {
      this.showSpecModal = true;
    },
    handleAddToCart() {
      this.showAddToCartModal = true;
    }
  }
});
